import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment, renderList as _renderList, withCtx as _withCtx, createVNode as _createVNode, Transition as _Transition, Teleport as _Teleport, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
  class: "p-6"
};
const _hoisted_2 = {
  key: 0,
  class: "flex items-center justify-center py-8"
};
const _hoisted_3 = {
  class: "flex items-center gap-2 mb-3 flex-wrap"
};
const _hoisted_4 = {
  key: 0,
  class: "px-2 py-0.5 bg-slate-100 text-slate-600 rounded text-xs"
};
const _hoisted_5 = {
  class: "text-xl font-semibold text-slate-900 mb-4"
};
const _hoisted_6 = {
  class: "flex items-center gap-2 text-sm text-slate-600 mb-4"
};
const _hoisted_7 = {
  class: "space-y-3 text-sm"
};
const _hoisted_8 = {
  key: 0,
  class: "flex items-start gap-2 text-slate-600"
};
const _hoisted_9 = {
  key: 1,
  class: "flex items-start gap-2 text-slate-600"
};
const _hoisted_10 = {
  class: "flex flex-wrap gap-3"
};
const _hoisted_11 = {
  class: "relative"
};
const _hoisted_12 = ["src", "alt"];
const _hoisted_13 = {
  key: 1,
  class: "w-6 h-6 rounded-full bg-slate-200 flex items-center justify-center text-xs text-slate-600"
};
const _hoisted_14 = {
  key: 2,
  class: "absolute -top-1.5 -right-1.5 text-amber-500",
  title: "待定"
};
const _hoisted_15 = {
  key: 3,
  class: "absolute -top-1.5 -right-1.5 text-green-500",
  title: "已接受"
};
const _hoisted_16 = {
  key: 4,
  class: "absolute -top-1.5 -right-1.5 text-red-500",
  title: "已拒绝"
};
const _hoisted_17 = {
  class: "text-slate-600 text-sm"
};
const _hoisted_18 = {
  key: 2,
  class: "text-slate-400"
};
const _hoisted_19 = {
  key: 3,
  class: "text-slate-600"
};
const _hoisted_20 = {
  key: 4,
  class: "pt-2 border-t border-slate-100"
};
const _hoisted_21 = {
  class: "space-y-1"
};
const _hoisted_22 = {
  key: 0,
  class: "flex items-center gap-2 text-slate-600"
};
const _hoisted_23 = {
  key: 1,
  class: "flex items-center gap-2 text-slate-600"
};
const _hoisted_24 = {
  key: 2,
  class: "flex items-center gap-2 text-slate-600"
};
const _hoisted_25 = {
  key: 3,
  class: "flex items-center gap-2 text-slate-600"
};
const _hoisted_26 = {
  key: 5,
  class: "pt-2 border-t border-slate-100 text-xs text-slate-400"
};
const _hoisted_27 = {
  key: 0
};
const _hoisted_28 = {
  class: "flex gap-3 mt-6"
};
import { computed } from 'vue';
import AppModal from '@/components/AppModal.vue';
export default {
  __name: 'ScheduleDetailModal',
  props: {
    show: {
      type: Boolean,
      default: false
    },
    event: {
      type: Object,
      default: () => ({})
    },
    loading: {
      type: Boolean,
      default: false
    },
    showEdit: {
      type: Boolean,
      default: true
    },
    showCancel: {
      type: Boolean,
      default: true
    }
  },
  emits: ['close', 'edit', 'accept', 'decline', 'cancel'],
  setup(__props) {
    /* eslint-disable no-unused-vars */
    const props = __props;

    // 日程类型映射
    const typeMap = {
      MEETING: {
        value: 'meeting',
        label: '会议',
        color: '#3B82F6'
      },
      TASK: {
        value: 'task',
        label: '任务',
        color: '#F59E0B'
      },
      CALL: {
        value: 'call',
        label: '电话',
        color: '#10B981'
      },
      DEADLINE: {
        value: 'deadline',
        label: '截止',
        color: '#EF4444'
      },
      OTHER: {
        value: 'other',
        label: '其他',
        color: '#6B7280'
      },
      meeting: {
        value: 'meeting',
        label: '会议',
        color: '#3B82F6'
      },
      task: {
        value: 'task',
        label: '任务',
        color: '#F59E0B'
      },
      call: {
        value: 'call',
        label: '电话',
        color: '#10B981'
      },
      deadline: {
        value: 'deadline',
        label: '截止',
        color: '#EF4444'
      },
      other: {
        value: 'other',
        label: '其他',
        color: '#6B7280'
      }
    };

    // 获取事件头部颜色类
    const eventHeaderClass = computed(() => {
      const typeInfo = typeMap[props.event?.typeBackend || props.event?.type] || typeMap.OTHER;
      return typeInfo.color;
    });

    // 获取类型标签
    const typeLabel = computed(() => {
      const typeInfo = typeMap[props.event?.typeBackend || props.event?.type] || typeMap.OTHER;
      return typeInfo.label;
    });

    // 获取类型徽章类
    const typeBadgeClass = computed(() => {
      const typeInfo = typeMap[props.event?.typeBackend || props.event?.type] || typeMap.OTHER;
      const color = typeInfo.color;
      const colorMap = {
        '#3B82F6': 'bg-blue-100 text-blue-700',
        '#F59E0B': 'bg-amber-100 text-amber-700',
        '#10B981': 'bg-green-100 text-green-700',
        '#EF4444': 'bg-red-100 text-red-700',
        '#6B7280': 'bg-slate-100 text-slate-700'
      };
      return colorMap[color] || 'bg-slate-100 text-slate-700';
    });

    // 获取参与状态标签
    const attendeeStatusMap = {
      1: {
        label: '待定',
        class: 'bg-amber-100 text-amber-700'
      },
      2: {
        label: '已接受',
        class: 'bg-green-100 text-green-700'
      },
      3: {
        label: '已拒绝',
        class: 'bg-red-100 text-red-700'
      }
    };
    const attendeeStatusLabel = computed(() => {
      return attendeeStatusMap[props.event?.attendeeStatus]?.label || '未知';
    });
    const attendeeStatusClass = computed(() => {
      return attendeeStatusMap[props.event?.attendeeStatus]?.class || 'bg-slate-100 text-slate-700';
    });
    return (_ctx, _cache) => {
      return _openBlock(), _createBlock(_Teleport, {
        to: "body"
      }, [_createVNode(_Transition, {
        name: "modal"
      }, {
        default: _withCtx(() => [_createVNode(AppModal, {
          visible: __props.show,
          size: "md",
          "panel-class": "mx-4",
          onClose: _cache[5] || (_cache[5] = $event => _ctx.$emit('close'))
        }, {
          default: _withCtx(() => [_createElementVNode("div", {
            class: _normalizeClass(['h-2 rounded-t-2xl', eventHeaderClass.value])
          }, null, 2), _createElementVNode("div", _hoisted_1, [__props.loading ? (_openBlock(), _createElementBlock("div", _hoisted_2, [...(_cache[6] || (_cache[6] = [_createElementVNode("svg", {
            class: "w-6 h-6 animate-spin text-blue-500",
            fill: "none",
            viewBox: "0 0 24 24"
          }, [_createElementVNode("circle", {
            class: "opacity-25",
            cx: "12",
            cy: "12",
            r: "10",
            stroke: "currentColor",
            "stroke-width": "4"
          }), _createElementVNode("path", {
            class: "opacity-75",
            fill: "currentColor",
            d: "M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
          })], -1)]))])) : __props.event ? (_openBlock(), _createElementBlock(_Fragment, {
            key: 1
          }, [_createElementVNode("div", _hoisted_3, [_createElementVNode("span", {
            class: _normalizeClass(['px-2 py-0.5 rounded text-xs font-medium', typeBadgeClass.value])
          }, _toDisplayString(typeLabel.value), 3), __props.event.isAllDay === 1 ? (_openBlock(), _createElementBlock("span", _hoisted_4, "全天")) : _createCommentVNode("", true), !__props.event.isOwner ? (_openBlock(), _createElementBlock("span", {
            key: 1,
            class: _normalizeClass(['px-2 py-0.5 rounded text-xs', attendeeStatusClass.value])
          }, _toDisplayString(attendeeStatusLabel.value), 3)) : _createCommentVNode("", true)]), _createElementVNode("h3", _hoisted_5, _toDisplayString(__props.event.title), 1), _createElementVNode("div", _hoisted_6, [_cache[7] || (_cache[7] = _createElementVNode("svg", {
            class: "w-4 h-4 flex-shrink-0",
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24"
          }, [_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"
          })], -1)), _createElementVNode("span", null, [_createTextVNode(_toDisplayString(__props.event.date) + " " + _toDisplayString(__props.event.time) + " ", 1), __props.event.endTime && __props.event.endTime !== __props.event.time ? (_openBlock(), _createElementBlock(_Fragment, {
            key: 0
          }, [_createTextVNode(" - " + _toDisplayString(__props.event.endTime), 1)], 64)) : _createCommentVNode("", true)])]), _createElementVNode("div", _hoisted_7, [__props.event.location ? (_openBlock(), _createElementBlock("div", _hoisted_8, [_cache[8] || (_cache[8] = _createElementVNode("svg", {
            class: "w-4 h-4 flex-shrink-0 mt-0.5",
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24"
          }, [_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z"
          }), _createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M15 11a3 3 0 11-6 0 3 3 0 016 0z"
          })], -1)), _createElementVNode("span", null, _toDisplayString(__props.event.location), 1)])) : _createCommentVNode("", true), __props.event.attendeeList && __props.event.attendeeList.length > 0 ? (_openBlock(), _createElementBlock("div", _hoisted_9, [_cache[12] || (_cache[12] = _createElementVNode("svg", {
            class: "w-4 h-4 flex-shrink-0 mt-0.5",
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24"
          }, [_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M12 4.354a4 4 0 110 5.292M15 21H3v-1a6 6 0 0112 0v1zm0 0h6v-1a6 6 0 00-9-5.197M13 7a4 4 0 11-8 0 4 4 0 018 0z"
          })], -1)), _createElementVNode("div", _hoisted_10, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.event.attendeeList, (person, index) => {
            return _openBlock(), _createElementBlock("div", {
              key: index,
              class: "flex items-center gap-1.5"
            }, [_createElementVNode("div", _hoisted_11, [person.avatar ? (_openBlock(), _createElementBlock("img", {
              key: 0,
              src: person.avatar,
              alt: person.userName,
              class: "w-6 h-6 rounded-full"
            }, null, 8, _hoisted_12)) : (_openBlock(), _createElementBlock("span", _hoisted_13, _toDisplayString((person.userName || '?').charAt(0)), 1)), person.status === 1 ? (_openBlock(), _createElementBlock("span", _hoisted_14, [...(_cache[9] || (_cache[9] = [_createElementVNode("svg", {
              class: "w-3.5 h-3.5",
              fill: "none",
              stroke: "currentColor",
              viewBox: "0 0 24 24"
            }, [_createElementVNode("path", {
              "stroke-linecap": "round",
              "stroke-linejoin": "round",
              "stroke-width": "2",
              d: "M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"
            })], -1)]))])) : person.status === 2 ? (_openBlock(), _createElementBlock("span", _hoisted_15, [...(_cache[10] || (_cache[10] = [_createElementVNode("svg", {
              class: "w-3.5 h-3.5",
              fill: "none",
              stroke: "currentColor",
              viewBox: "0 0 24 24"
            }, [_createElementVNode("path", {
              "stroke-linecap": "round",
              "stroke-linejoin": "round",
              "stroke-width": "2",
              d: "M5 13l4 4L19 7"
            })], -1)]))])) : person.status === 3 ? (_openBlock(), _createElementBlock("span", _hoisted_16, [...(_cache[11] || (_cache[11] = [_createElementVNode("svg", {
              class: "w-3.5 h-3.5",
              fill: "none",
              stroke: "currentColor",
              viewBox: "0 0 24 24"
            }, [_createElementVNode("path", {
              "stroke-linecap": "round",
              "stroke-linejoin": "round",
              "stroke-width": "2",
              d: "M6 18L18 6M6 6l12 12"
            })], -1)]))])) : _createCommentVNode("", true)]), _createElementVNode("span", _hoisted_17, _toDisplayString(person.userName), 1)]);
          }), 128))])])) : (_openBlock(), _createElementBlock("span", _hoisted_18, "无")), __props.event.description ? (_openBlock(), _createElementBlock("p", _hoisted_19, _toDisplayString(__props.event.description), 1)) : _createCommentVNode("", true), __props.event.customerName || __props.event.opportunityName || __props.event.contractName || __props.event.projectName ? (_openBlock(), _createElementBlock("div", _hoisted_20, [_cache[17] || (_cache[17] = _createElementVNode("p", {
            class: "text-xs font-medium text-slate-500 mb-2"
          }, "关联信息", -1)), _createElementVNode("div", _hoisted_21, [__props.event.customerName ? (_openBlock(), _createElementBlock("div", _hoisted_22, [_cache[13] || (_cache[13] = _createElementVNode("span", {
            class: "px-1.5 py-0.5 bg-blue-50 text-blue-600 rounded text-xs"
          }, "客户", -1)), _createElementVNode("span", null, _toDisplayString(__props.event.customerName), 1)])) : _createCommentVNode("", true), __props.event.opportunityName ? (_openBlock(), _createElementBlock("div", _hoisted_23, [_cache[14] || (_cache[14] = _createElementVNode("span", {
            class: "px-1.5 py-0.5 bg-purple-50 text-purple-600 rounded text-xs"
          }, "商机", -1)), _createElementVNode("span", null, _toDisplayString(__props.event.opportunityName), 1)])) : _createCommentVNode("", true), __props.event.contractName ? (_openBlock(), _createElementBlock("div", _hoisted_24, [_cache[15] || (_cache[15] = _createElementVNode("span", {
            class: "px-1.5 py-0.5 bg-green-50 text-green-600 rounded text-xs"
          }, "合同", -1)), _createElementVNode("span", null, _toDisplayString(__props.event.contractName), 1)])) : _createCommentVNode("", true), __props.event.projectName ? (_openBlock(), _createElementBlock("div", _hoisted_25, [_cache[16] || (_cache[16] = _createElementVNode("span", {
            class: "px-1.5 py-0.5 bg-amber-50 text-amber-600 rounded text-xs"
          }, "项目", -1)), _createElementVNode("span", null, _toDisplayString(__props.event.projectName), 1)])) : _createCommentVNode("", true)])])) : _createCommentVNode("", true), __props.event.createdAt ? (_openBlock(), _createElementBlock("div", _hoisted_26, [_createElementVNode("p", null, "创建于 " + _toDisplayString(new Date(__props.event.createdAt).toLocaleString('zh-CN')), 1), __props.event.updatedAt && __props.event.updatedAt !== __props.event.createdAt ? (_openBlock(), _createElementBlock("p", _hoisted_27, " 更新于 " + _toDisplayString(new Date(__props.event.updatedAt).toLocaleString('zh-CN')), 1)) : _createCommentVNode("", true)])) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_28, [!__props.event.isOwner && __props.event.attendeeStatus === 1 ? (_openBlock(), _createElementBlock(_Fragment, {
            key: 0
          }, [_createElementVNode("button", {
            onClick: _cache[0] || (_cache[0] = $event => _ctx.$emit('accept')),
            type: "button",
            class: "flex-1 px-4 py-2 text-sm font-medium text-white bg-green-500 rounded-lg hover:bg-green-600 transition-colors flex items-center justify-center gap-2"
          }, [...(_cache[18] || (_cache[18] = [_createElementVNode("svg", {
            class: "w-4 h-4",
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24"
          }, [_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M5 13l4 4L19 7"
          })], -1), _createTextVNode(" 接受 ", -1)]))]), _createElementVNode("button", {
            onClick: _cache[1] || (_cache[1] = $event => _ctx.$emit('decline')),
            type: "button",
            class: "flex-1 px-4 py-2 text-sm font-medium text-white bg-red-500 rounded-lg hover:bg-red-600 transition-colors flex items-center justify-center gap-2"
          }, [...(_cache[19] || (_cache[19] = [_createElementVNode("svg", {
            class: "w-4 h-4",
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24"
          }, [_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M6 18L18 6M6 6l12 12"
          })], -1), _createTextVNode(" 拒绝 ", -1)]))])], 64)) : (_openBlock(), _createElementBlock(_Fragment, {
            key: 1
          }, [__props.event.isOwner && __props.showEdit ? (_openBlock(), _createElementBlock("button", {
            key: 0,
            onClick: _cache[2] || (_cache[2] = $event => _ctx.$emit('edit')),
            type: "button",
            class: "flex-1 px-4 py-2 text-sm font-medium text-white bg-blue-500 rounded-lg hover:bg-blue-600 transition-colors"
          }, " 编辑 ")) : !__props.event.isOwner && __props.event.attendeeStatus === 2 && __props.showCancel ? (_openBlock(), _createElementBlock("button", {
            key: 1,
            onClick: _cache[3] || (_cache[3] = $event => _ctx.$emit('cancel')),
            type: "button",
            class: "flex-1 px-4 py-2 text-sm font-medium text-white bg-red-500 rounded-lg hover:bg-red-600 transition-colors"
          }, " 取消参与 ")) : _createCommentVNode("", true), _createElementVNode("button", {
            onClick: _cache[4] || (_cache[4] = $event => _ctx.$emit('close')),
            type: "button",
            class: _normalizeClass(__props.event.isOwner && __props.showEdit ? 'px-4 py-2 text-sm font-medium text-slate-700 bg-slate-100 rounded-lg hover:bg-slate-200 transition-colors' : 'flex-1 px-4 py-2 text-sm font-medium text-slate-700 bg-slate-100 rounded-lg hover:bg-slate-200 transition-colors')
          }, _toDisplayString(__props.event.isOwner && __props.showEdit ? '关闭' : '我知道了'), 3)], 64))])], 64)) : _createCommentVNode("", true)])]),
          _: 1
        }, 8, ["visible"])]),
        _: 1
      })]);
    };
  }
};